<template>
<div>
    <About size="sm" ref="aboutDialogRef"></About>
    <header v-if="!theme.menuOnTop" id="navbar-menu-left" class="mcc-navigation-header mcc-navigation-header--fixed no-print" aria-label="Advanced Product" role="banner" :style="$store.getters.getDrawerStatus && !$store.getters.getSmallScreenStatus ? { left: 'var(--mcc-drawer-width)' } : {}">
        <nav class="mcc-navigation-header__nav">
            <button id="drawer-toggle" @click="toggleDrawer" class=" mcc-navigation-header__button mcc-navigation-header__button--icon-only">
                <mcc-icon name="menu" icon-set="fluency-outline" aria-hidden="true" class="mcc-icon"></mcc-icon>
                <span>Toggle navigation drawer</span>
            </button>
            <div class=" mu-my-05 mu-p-03">
                <span class="mcc-chip mcc-chip--xs mcc-chip--outline">{{ selectedWorkplaceReference }}</span>
            </div>
        </nav>
        <nav class="mcc-navigation-header__global" role="navigation" aria-label="Global Navigation">
            <button class="mcc-navigation-header__button mu-d-none" @click="exitPreviewMode()" v-show="previewMode">
                <mcc-icon name="image" aria-hidden="true"></mcc-icon><span class="mcc-button__label">
                    <span class="mcc-chip mcc-chip--xs mcc-chip--danger ">Exit preview mode</span>
                </span>
            </button>
            <details class="mcc-dropdown mcc-dropdown--sw" id="startProcessDropdown" :key="categoriesDropdownKey" title="Start process">
                <summary aria-haspopup="true">
                    <div class="mcc-navigation-header__button">
                        <mcc-icon name="start" aria-hidden="true"></mcc-icon>
                        <span class="mu-d-none mu-d-md-block">Start Process</span>
                        <mcc-icon class="mcc-dropdown__toggle-icon" name="expand_arrow" aria-hidden="true"></mcc-icon>
                    </div>
                </summary>
                <div class="[ mcc-dropdown__menu ] [ mu-overflow-visible ] [mu-border-0] dropDrillDownOverflow">
                    <Drilldown :is-root="true">
                        <ul role="menubar">
                            <li role="none">
                                <button class="mcc-button nav-button mcc-button--sm mcc-button--outline"
                                style="border-color: #a5a5b6 !important; border: solid #a5a5b6 !important; border-width: 1px !important;" type="button" @click="viewProcesses()" title="View processes" role="menuitem">
                                    <span>View processes</span></button>
                            </li>
                            <div class="mu-border-bottom mu-my-03" ></div>
                            
                            <DrilldownItem v-for="(node, index) in categories.children" :key="index" :node="node"></DrilldownItem>
                        </ul>
                    </Drilldown>
                </div>
            </details>
            <details class="mcc-dropdown mcc-dropdown--sw" :title="navbarProperty.userName" id="profileDropdown">
                <summary aria-haspopup="true">
                    <div class="mcc-navigation-header__button">
                        <mcc-icon name="user" aria-hidden="true"></mcc-icon>
                        <span class="mu-d-none mu-d-md-block">{{navbarProperty.userName}}</span>
                        <mcc-icon class="mcc-dropdown__toggle-icon" name="expand_arrow" aria-hidden="true"></mcc-icon>
                    </div>
                </summary>
                <ul class="mcc-dropdown__menu">
                    <li @click="closeDropdown">
                        <NavigationButton id="profileNav" :to="CONTEXT_PATH + '/user/profile'" label="Profile" icon="edit_profile" />
                        <button v-if="showHelpUrl()" id="helpNav" @click="getAbsoluteUrl(helpUrl)">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Help</span>
                        </button>
                        <button v-show="isEnablePrivacyPolicy()" id="policyNav" @click="getAbsoluteUrl(privacyPolicyLinkUrl)" :title="privacyPolicyLinkName">
                            <mcc-icon name="privacy" aria-hidden="true"></mcc-icon><span class="mcc-button__label">{{privacyPolicyLinkName }}</span>
                        </button>
                        <button id="aboutNav" @click="openAboutDialog" label="About">
                            <mcc-icon name="info" aria-hidden="true"></mcc-icon><span class="mcc-button__label">About</span>
                        </button>
                        <NavigationButton id="dashboardNav" :to="CONTEXT_PATH + '/user/dashboard'" label="Dashboard" icon="dashboard" />
                        <button id="logoutNav" @click="performLogout" label="Logout">
                            <mcc-icon name="logout_rounded" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Logout</span>
                        </button>
                    </li>
                </ul>
            </details>
        </nav>
    </header>
    <header v-if="theme.menuOnTop" id="navbar-menu-top" class="mcc-navigation-header mcc-navigation-header--fixed no-print" aria-label="Advanced Product" role="banner">
        <nav class="mcc-navigation-header__nav">
            <div class="mcc-menu__title">
                <img :src="(theme.logo != null && theme.logo != '') ? theme.logo : 'https://cdn.svc.oneadvanced.com/mosaic/2.0.0/img/logo.svg'" alt="Logo" style="height: 40px; width: 40px;" /><span class="h5 productName">{{theme.productName}}</span></div>
            <div class=" mu-my-05 mu-p-03">
                <span class="mcc-chip mcc-chip--outline mcc-chip--xs">{{selectedWorkplaceReference}}</span>
            </div>
        </nav>
        <nav class="mcc-navigation-header__global" role="navigation" aria-label="Global Navigation">
            <button class="mcc-navigation-header__button mu-d-none" title="Exit Preview Mode" @click="exitPreviewMode()" v-show="previewMode">
                <mcc-icon name="image" aria-hidden="true"></mcc-icon><span class="mcc-button__label">
                </span>
            </button>
            <details class="mcc-dropdown" id="startProcessDropdown" :key="categoriesDropdownKey" title="Start process">
                <summary aria-haspopup="true">
                    <div class="mcc-button">
                        <mcc-icon name="start" aria-hidden="true"></mcc-icon>
                        <mcc-icon class="mcc-dropdown__toggle-icon" name="expand_arrow" aria-hidden="true"></mcc-icon>
                    </div>
                </summary>
                <ul class="mcc-dropdown__menu">
                    <li @click="closeDropdown">
                        <NavigationButton label="View processes" title="View processes" :to=" this.CONTEXT_PATH + '/category/view/Home'" icon="view_details" />
                        <NavigationButton :id="'category-'+key" v-for="(category,key) in allCategoriesArr" :icon="category.icon" :key="key" :title="category.value.name" :label="category.value.name" :to="CONTEXT_PATH + '/category/view/' +category.value.name" />
                    </li>
                </ul>
            </details>
            <details class="mcc-dropdown" id="myProcessDropdown" title="My processes">
                <summary aria-haspopup="true">
                    <div class="mcc-button">
                        <mcc-icon name="process" aria-hidden="true"></mcc-icon>
                        <mcc-icon class="mcc-dropdown__toggle-icon" name="expand_arrow" aria-hidden="true"></mcc-icon>
                    </div>
                </summary>
                <ul class="mcc-dropdown__menu">
                    <li @click="closeDropdown">
                        <NavigationButton id="startedByMeNav" title="Started by me" label="Started by me" :to="CONTEXT_PATH + '/processes/startedbyme'" />
                        <NavigationButton id="allInvolvedNav" title="All involved" label="All involved" :to="CONTEXT_PATH + '/processes/involvingme'" />
                        <NavigationButton id="draftsProcessNav" title="Drafts" label="Drafts" :to="CONTEXT_PATH + '/processes/drafts'" />
                    </li>
                </ul>
            </details>
            <details class="mcc-dropdown" id="myTasksDropdown" title="My tasks">
                <summary aria-haspopup="true">
                    <div class="mcc-button">
                        <mcc-icon name="tasks" aria-hidden="true"></mcc-icon>

                        <mcc-icon class="mcc-dropdown__toggle-icon" name="expand_arrow" aria-hidden="true"></mcc-icon>
                    </div>
                </summary>
                <ul class="mcc-dropdown__menu">
                    <li @click="closeDropdown">
                        <NavigationButton id="assignedTaskNav" title="Assigned" label="Assigned" :to="CONTEXT_PATH + '/tasks/assigned'" />
                        <NavigationButton id="unclaimedTaskNav" title="Unclaimed" label="Unclaimed" :to="CONTEXT_PATH + '/tasks/unclaimed'" />
                        <NavigationButton id="allInvolvedTaskNav" title="All involved" label="All involved" :to="CONTEXT_PATH + '/tasks/involvingme'" />
                        <NavigationButton id="draftsTaskNav" title="Drafts" label="Drafts" :to="CONTEXT_PATH + '/tasks/drafts'" />
                    </li>
                </ul>
            </details>
            <details class="mcc-dropdown" id="processEngineDropdown" :key="processEngineNavKey" title="Process engine">
                <summary aria-haspopup="true">
                    <div class="mcc-button">
                        <mcc-icon name="gears" aria-hidden="true"></mcc-icon>
                        <mcc-icon class="mcc-dropdown__toggle-icon" name="expand_arrow" aria-hidden="true"></mcc-icon>
                    </div>
                </summary>
                <ul class="mcc-dropdown__menu">
                    <li @click="closeDropdown">
                        <NavigationButton id="deploymentNav" title="Deployments" label="Deployments" :to="CONTEXT_PATH + '/processengine/deployment'" icon="deployment" />
                        <NavigationButton id="definitionNav" title="Definitions" label="Definitions" :to="CONTEXT_PATH + '/processengine/processdefinitions'" icon="brief" />
                        <NavigationButton id="viewInstancesNav" title="View instances" label="View instances" :to="CONTEXT_PATH + '/processengine/processes'" icon="prototype" />
                        <NavigationButton :id="'viewCustomProcessNav-'+key" v-for="(view,key) in processCustomViews" :key="'process-'+key" :to="CONTEXT_PATH + '/processengine/processes/customview/' + view.id" :title="view.aliasName" :label="view.aliasName" icon="deployment" />
                        <NavigationButton id="viewTasksNav" title="View tasks" label="View tasks" :to="CONTEXT_PATH + '/processengine/tasks'" icon="tasks" />
                        <NavigationButton :id="'viewCustomTaskNav-'+key" v-for="(view,key) in taskCustomViews" :key="'tasks-'+key" :to="CONTEXT_PATH + '/processengine/tasks/customview/' + view.id" :title="view.aliasName" :label="view.aliasName" icon="deployment" />
                        <NavigationButton id="jobsNav" title="Jobs" label="Jobs" :to="CONTEXT_PATH + '/processengine/jobs'" icon="job" />
                        <NavigationButton id="processErrorsNav" title="Process errors" label="Process errors" :to="CONTEXT_PATH + '/processengine/processFailure'" icon="error" />
                    </li>
                </ul>
            </details>
            <details class="mcc-dropdown" id="designDropdown" title="Design">
                <summary aria-haspopup="true">
                    <div class="mcc-button">
                        <mcc-icon name="design" aria-hidden="true"></mcc-icon>
                        <mcc-icon class="mcc-dropdown__toggle-icon" name="expand_arrow" aria-hidden="true"></mcc-icon>
                    </div>
                </summary>
                <ul class="mcc-dropdown__menu">
                    <li @click="closeDropdown">
                        <NavigationButton id="applicationsNav" title="Applications" label="Applications" :to="CONTEXT_PATH + '/design/applications'" icon="mesh" />
                        <NavigationButton id="categoriesNav" title="Categories" label="Categories" :to="CONTEXT_PATH + '/design/categories'" icon="categorize" />
                        <NavigationButton id="globalPropertiesNav" title="Global properties" label="Global properties" :to="CONTEXT_PATH + '/design/globalProcessProperties'" icon="property_script" />
                        <NavigationButton id="appProcessesNav" title="Processes" label="Processes" :to="CONTEXT_PATH + '/design/applications/appprocesses'" icon="process" />
                        <NavigationButton id="appFormsNav" title="Forms" label="Forms" :to="CONTEXT_PATH + '/design/forms'" icon="form" />
                        <NavigationButton id="formTemplatesNav" title="Form templates" label="Form templates" :to="CONTEXT_PATH + '/design/formTemplates'" icon="form" />
                        <NavigationButton id="emailTemplatesNav" title="Email templates" label="Email templates" :to="CONTEXT_PATH + '/design/emailTemplates'" icon="gmail" />
                        <NavigationButton id="customDataListNav" title="Custom data list" label="Custom data list" :to="CONTEXT_PATH + '/design/customdatalist'" icon="list" />
                    </li>
                </ul>
            </details>
            <details class="mcc-dropdown" id="integrateDropdown" title="Integrate">
                <summary aria-haspopup="true">
                    <div class="mcc-button">
                        <mcc-icon name="external_link" aria-hidden="true"></mcc-icon>
                        <mcc-icon class="mcc-dropdown__toggle-icon" name="expand_arrow" aria-hidden="true"></mcc-icon>
                    </div>
                </summary>
                <ul class="mcc-dropdown__menu">
                    <li @click="closeDropdown">
                        <NavigationButton id="externalSystemsNav" title="External systems" label="External systems" :to="CONTEXT_PATH + '/integrate/externalsystems'" icon="external_link" />
                    </li>
                </ul>
            </details>
            <details class="mcc-dropdown" id="usersGroupsDropdown" title="Users & groups">
                <summary aria-haspopup="true">
                    <div class="mcc-button">
                        <mcc-icon name="conference" aria-hidden="true"></mcc-icon>
                        <mcc-icon class="mcc-dropdown__toggle-icon" name="expand_arrow" aria-hidden="true"></mcc-icon>
                    </div>
                </summary>
                <ul class="mcc-dropdown__menu">
                    <li @click="closeDropdown">
                        <NavigationButton id="usersNav" title="Users" label="Users" :to="CONTEXT_PATH + '/usersgroups/users'" icon="user" />
                        <NavigationButton id="userPropertiesNav" title="User properties" label="User properties" :to="CONTEXT_PATH + '/usersgroups/userProperties'" icon="content" />
                        <NavigationButton id="groupsNav" title="Groups" label="Groups" :to="CONTEXT_PATH + '/usersgroups/groups'" icon="conference" />
                        <NavigationButton id="hierarchiesNav" title="Hierarchies" label="Hierarchies" :to="CONTEXT_PATH + '/usersgroups/hierarchies'" icon="tree_structure" />
                        <NavigationButton id="rolesNav" title="Roles" label="Roles" :to="CONTEXT_PATH + '/usersgroups/roles'" icon="add_user_male" />
                    </li>
                </ul>
            </details>
            <details class="mcc-dropdown" id="administrationDropdown" title="Administration">
                <summary aria-haspopup="true">
                    <div class="mcc-button">
                        <mcc-icon name="wrench" aria-hidden="true"></mcc-icon>

                        <mcc-icon class="mcc-dropdown__toggle-icon" name="expand_arrow" aria-hidden="true"></mcc-icon>
                    </div>
                </summary>
                <ul class="mcc-dropdown__menu">
                    <li @click="closeDropdown">
                        <NavigationButton id="dashboardNav" title="Dashboard" label="Dashboard" :to="CONTEXT_PATH + '/admin/dashboard'" icon="dashboard" />
                        <NavigationButton id="importExportNav" title="Import/Export" label="Import/Export" :to="CONTEXT_PATH + '/admin/importexport'" icon="swap" />
                        <NavigationButton id="systemTemplateNav" title="System templates" label="System templates" :to="CONTEXT_PATH + '/admin/systemTemplates'" icon="template" />
                        <NavigationButton id="auditHistoryNav" title="Audit history" label="Audit history" :to="CONTEXT_PATH + '/admin/audit'" icon="past" />
                        <NavigationButton id="settingsNav" title="Settings" label="Settings" :to="CONTEXT_PATH + '/admin/settings'" icon="settings" />
                        <NavigationButton id="themesNav" title="Themes" label="Themes" :to="CONTEXT_PATH + '/admin/themes'" icon="calligraphy_brush" />
                        <NavigationButton id="licenceManagement" title="Licence Management" label="Licence Management" :to="CONTEXT_PATH + '/admin/licenceManagement'" icon="software_license" />
                        <button v-if="navbarProperty.monitorEnabled == 'true'" id="monitorNav" @click="getAbsoluteUrl(navbarProperty.monitorURL)">
                            <mcc-icon name="clock" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Monitor Application</span>
                        </button>
                    </li>
                </ul>
            </details>
            <details class="mcc-dropdown mcc-dropdown--sw" id="profileDropdown" :title="navbarProperty.userName" :tooltip="navbarProperty.userName">
                <summary aria-haspopup="true">
                    <div class="mcc-button">
                        <mcc-icon name="user" aria-hidden="true"></mcc-icon>
                        <mcc-icon class="mcc-dropdown__toggle-icon" name="expand_arrow" aria-hidden="true"></mcc-icon>
                    </div>
                </summary>
                <ul class="mcc-dropdown__menu">
                    <li @click="closeDropdown">
                        <NavigationButton id="profileNav" :to="CONTEXT_PATH + '/user/profile'" title="Profile" label="Profile" icon="account" />
                        <button v-if="showHelpUrl()" title="Help" id="helpNav" @click="getAbsoluteUrl(helpUrl)">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Help</span>
                        </button>
                        <button v-show="isEnablePrivacyPolicy()" id="policyNav" @click="getAbsoluteUrl(privacyPolicyLinkUrl)" :title="privacyPolicyLinkName">
                            <mcc-icon name="privacy" aria-hidden="true"></mcc-icon><span class="mcc-button__label">{{privacyPolicyLinkName}}</span>
                        </button>
                        <NavigationButton id="aboutNav" dialog="aboutInfo-dialog" title="About" label="About" icon="info" />
                        <NavigationButton id="dashboardNav" :to="CONTEXT_PATH + '/user/dashboard'" title="Dashboard" label="Dashboard" icon="dashboard" />
                        <button id="logoutNav" @click="performLogout" title="Logout" label="Logout">
                            <mcc-icon name="logout_rounded" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Logout</span>
                        </button>
                    </li>
                </ul>
            </details>
        </nav>
    </header>
</div>
</template>
<script>
import NavigationButton from './NavigationButton.vue'
import About from "../About/About";
import constants from "../../constants";
import axios from "axios";
import DrilldownItem from './DrilldownItem.vue'
import Drilldown from './Drilldown.vue';
import {
    EventBus
} from "@/services/event-bus";
import {
    mapState
} from "vuex";
export default {
    props: ['navbarProperty'],
    components: {
        NavigationButton,
        About,
        DrilldownItem,
        Drilldown
    },
    computed: {
        ...mapState(['previewMode'])

    },
    data() {
        return {
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            BASE_URL: process.env.BASE_URL,
            customViews: {},
            taskCustomViews: {},
            processCustomViews: {},
            theme: {},
            categories: {},
            allCategoriesArr: [],
            processEngineNavKey: 0,
            categoriesDropdownKey: 1,
            privacyPolicyLinkName: "",
            privacyPolicyLinkUrl: "",
            helpUrl: "",
            userProfile: {},
            selectedWorkplaceReference: "",
            userWorkplaceReferences: [],
            isAdvancedSSO: false,
        }
    },
    mounted() {
        let self = this;

        self.customViews = self.$store.getters.getCustomViews;
        self.taskCustomViews = self.customViews.taskTypeList;
        self.processCustomViews = self.customViews.processTypeList;
        self.categories = self.$store.getters.getCategories;
        self.theme = self.$store.getters.getThemeData;
        self.userProfile = self.$store.getters.getUserProfile;
        self.applyTheme();

        self.createCategoriesArrayForMenuOnTop();

        EventBus.$on("updateCustomViewDrilldown", result => {
            self.taskCustomViews = [];
            setTimeout(() => {
                self.taskCustomViews = result;
                self.processEngineNavKey += 1;
            }, 1000);
        });
        EventBus.$on("updateCustomViewProcessDrilldown", result => {
            self.processCustomViews = [];
            setTimeout(() => {
                self.processCustomViews = result;
                self.processEngineNavKey += 1;
            }, 1000);
        });
        EventBus.$on("updateCategoriesDrilldown", result => {
            self.categories = {};
            setTimeout(() => {
                self.categories = result;
                self.allCategoriesArr = [];
                self.createCategoriesArrayForMenuOnTop();
                self.categoriesDropdownKey += 1;
            }, 1000);
        });

        EventBus.$on("updateTheme", result => {
            self.theme = result;
            self.applyTheme();
        });

        this.selectedWorkplaceReference = self.$store.getters.getSelectedWorksPlace;
        let wrf = self.$store.getters.getWorksPlaceReferences;
        if (wrf) {
            wrf = wrf.toString().split(",");
            this.userWorkplaceReferences = wrf.slice();
            this.userWorkplaceReferences = this.userWorkplaceReferences.filter(a => a != this.selectedWorkplaceReference);
        }
        this.isAdvancedSSO = self.$store.getters.getIsAdvancedSSO;

    },
    methods: {
        viewProcesses() {
            this.$router.push(
                this.CONTEXT_PATH +
                "/category/view/Home"
            );
        },
        closeDropdown() {
            $('.mcc-dropdown').removeAttr('open');
        },
        openAboutDialog() {
            this.$refs.aboutDialogRef.aboutDialogShowHandler();
        },
        toggleDrawer() {
            let self = this;
            EventBus.$emit("ToggleDrawer");
        },
        showHelpUrl() {
            this.helpUrl = this.$store.getters.getHelpUrl;
            return true;
        },
        isEnablePrivacyPolicy() {
            this.privacyPolicyLinkName = this.$store.getters.getPrivacyPolicyLinkName;
            this.privacyPolicyLinkUrl = this.$store.getters.getPrivacyPolicyLinkUrl;
            return this.$store.getters.getEnablePrivacyPolicy == "true";
        },
        performLogout() {
            window.location = process.env.VUE_APP_CONTEXT_PATH + "/logout";
        },
        getAbsoluteUrl(urlToAppend) {
            if (urlToAppend.indexOf('http')) {
                urlToAppend = 'http://' + urlToAppend;
            }

            window.open(
                urlToAppend,
                "_blank");
        },
        exitPreviewMode() {
            EventBus.$emit("exitPreviewMode");
            this.applyTheme();
        },
        applyTheme() {
            let self = this;
            setTimeout(() => {
                if (self.theme.menuOnTop) {
                    $("#mainPageMiddleContainer, mosaic-footer").addClass("noMarginLeft");
                } else {
                    $("#mainPageMiddleContainer, mosaic-footer").removeClass("noMarginLeft");
                }
            }, 0);

            var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            if (self.theme.favicon != null) {
                link.href = self.theme.favicon;
            } else {
                link.href = "/favicon.ico";
            }
            document.getElementsByTagName('head')[0].appendChild(link);

            setTimeout(() => {
                if (self.theme.logo != null && self.theme.logo != "") {
                    $("mosaic-app-name img").attr("src", self.theme.logo);
                } else {
                    $("mosaic-app-name img").attr("src", "https://cdn.svc.oneadvanced.com/mosaic/2.0.0/img/logo.svg");
                }
            }, 1000);

            setTimeout(() => {
                // var mosaicColorList = ["#242424", "#400040", "#666600", "#d23600", "#5f5f5f", "#293462", "#472323", "#ff0000"]

                //var themeColor = (self.theme.themeName != null && self.theme.themeName != "" && mosaicColorList.indexOf(self.theme.themeName) != -1) ? self.theme.themeName : "#242424";
                // $("#themeControl")[0].generateCss(themeColor);
                // $("#themeControl")[0].preview();
                //const theme = document.querySelector('mosaic-user-defined-theme')
                //theme.generateCss(themeColor)
                //theme.preview()

                this.$store.dispatch('updatePreviewMode', false)
                let themeCode = ''
                if (this.theme && this.theme.themeCode && this.theme.themeCode != '') {
                    themeCode = this.theme.themeCode
                }
                if (this.userProfile && this.userProfile.themeCode && this.userProfile.themeCode != '') {
                    const userSelectedTheme = this.$store.getters.getThemeFromCode(this.userProfile.themeCode);
                    if (userSelectedTheme) {
                        themeCode = this.userProfile.themeCode
                    }
                }
                if (themeCode && themeCode != '' && themeCode != 'theme-default') {
                    const selectedTheme = this.$store.getters.getThemeFromCode(themeCode)
                    if (selectedTheme && selectedTheme.variables) {
                        const theme = document.querySelector('mosaic-user-defined-theme')
                        const variables = JSON.parse(selectedTheme.variables)
                        theme.theme = variables;
                        //theme.generateCss(variables['navbar-bg-lg'])
                        theme.preview()
                    }
                } else {
                    const theme = document.querySelector('mosaic-user-defined-theme')
                    // theme.generateCss('#242424')
                    // theme.preview()
                }
            }, 0);

            $("mosaic-app-name span").attr("title", self.theme.productName);
        },
        createCategoriesArrayForMenuOnTop() {
            let self = this;
            $.each(self.categories.children, function (i, value) {
                if (value.children.length > 0) {
                    self.allCategoriesArr.push({
                        "value": value,
                        "icon": "folder"
                    });
                    self.loadChildrens(value);
                } else {
                    self.allCategoriesArr.push({
                        "value": value,
                        "icon": "category"
                    });
                }
            });
        },
        loadChildrens(category) {
            let self = this;
            $.each(category.children, function (i, value) {
                if (value.children.length > 0) {
                    self.allCategoriesArr.push({
                        "value": value,
                        "icon": "folder"
                    });
                    self.loadChildrens(value);
                } else {
                    self.allCategoriesArr.push({
                        "value": value,
                        "icon": "category"
                    });
                }
            });
        },
        switchWorkplace(val) {

            axios.defaults.withCredentials = true;

            axios
                .post(constants.BASE_URL + "/usersgroups/usersAPI/updateTenant", null, {
                    params: {
                        selectedWrf: val,
                    },
                })
                .then((response) => {
                    window.location = process.env.VUE_APP_CONTEXT_PATH + "/category/view/Home";
                })
                .catch((error) => console.log("Error while updating tenant :" + error));

        }

    }
}
</script>

<style scoped>
span#workplaceValue {
    background-color: darkblue;
    color: cornsilk;
}

.dropDrillDownOverflow {
    overflow: auto !important;
    max-height: 90vh !important;
}
</style>
